import { RouteRecordRaw } from 'vue-router';

// ウォレットサービス関連
export const walletServiceRoutes: Array<RouteRecordRaw> = [
  {
    name: 'WalletService',
    component: () => import('@/components/pages/wallet-service/index.vue'),
    path: '/wallet-service',
    meta: {
      title: 'ウォレットサービス',
      requiredAuthority: 'WALLET_SERVICES',
    },
  },
  {
    name: 'WalletServiceId',
    component: () => import('@/components/pages/wallet-service/detail/index.vue'),
    path: '/wallet-service/:id',
    meta: {
      title: 'ウォレットサービス詳細',
      requiredAuthority: 'WALLET_SERVICES',
    },
  },
];
